import { useRef, useEffect } from "react";

import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import ChevronDownIcon from "@/icons/ChevronDownIcon";
import ActivityHeader from "@/view/ActivityHeader";
import useActivityPanel from "@/view/utils/useActivityPanel";
import { rootCss, iconCss } from "./ActivityPanelTab.style";

const propTypes = {
  isStudent: PropTypes.bool,
  onClick: PropTypes.func,
};

const ActivityPanelTab = ({ isStudent, onClick }) => {
  const ref = useRef();
  const { isActivityPanelExpanded } = useActivityPanel();

  useEffect(() => {
    ref?.current?.focus();
  }, [isActivityPanelExpanded]);

  return (
    <Button
      onClick={onClick}
      flavor={Button.flavors.incognito}
      __cssFor={{ root: rootCss(!isStudent) }}
      ref={ref}
    >
      <ActivityHeader isStudent={isStudent} />
      <ChevronDownIcon css={iconCss} />
    </Button>
  );
};

ActivityPanelTab.propTypes = propTypes;

export default ActivityPanelTab;
